const updateVideoSize = require('./update-video-size');

module.exports = function () {

    if ($('.product-hero-module').length === 0) {
        return;
    }    

    updateVideoSize();        

    $(window).resize(function () {
        updateVideoSize();
    });
};